import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PATHS } from '../common/constants';
import Asset from '../pages/Asset';
import Contact from '../pages/Contact';
import Item from '../pages/Item';
import ServiceRequest from '../pages/ServiceRequest';
import Settings from '../pages/Settings/Settings';
import Suite from '../pages/Suite';
import VideoChat from '../pages/VideoChat';
import ViewImage from '../pages/ViewImage';
import Dashboard from '../pages/HomeOwnerDashboard/Dashboard';
import EventAddingWithCalendly from '../pages/CalendlyIntegration/EventAdding';
import Announcements from '../pages/Announcements/Announcements';
import Announcementsview from '../pages/Announcements/Announcementsview';
import CommonArea from '../pages/CommonArea';
import Reporting from '../pages/Reporting/Reporting';
import KeyContacts from '../pages/KeyContacts';
import KeyContact from '../pages/KeyContact';
import OnboardingDashboard from '../pages/HomeOwnerDashboard/HomeOwnerOnboardingContainer';
import InboxContainer from '../pages/Inbox/InboxContainer';
import { useSelector } from 'react-redux';
import { checkUserPermission } from '../helpers/validationHelper';
import Property from 'src/pages/Property/Property';

const HomeownerRoutes = () => {
  const tabSelections = useSelector(
    (state: any) => state?.tabSelections?.allowedTabList || []
  );

  const showInbox: boolean = checkUserPermission('Inbox', null, null);

  const checkAnnouncement: any =
    tabSelections?.find((ts: any) => ts.name === 'Announcements') || {};

  return (
    <Switch>
        <Route path={PATHS.SETTINGS} component={Settings} />
        <Route path={PATHS.ASSETS_VIEW} component={Asset} />
        <Route path={PATHS.CONTACTS_VIEW} component={Contact} />
        <Route path={PATHS.KEY_CONTACTS_VIEW} component={KeyContact} />
        <Route path={PATHS.KEY_CONTACTS_LIST} component={KeyContacts} />
        <Route path={PATHS.PROPERTIES_VIEW} component={Property} />
        <Route path={PATHS.ITEMS_VIEW} component={Item} />
        <Route path={PATHS.SERVICE_REQUESTS_VIEW} component={ServiceRequest} />
        <Route path={PATHS.SUITES_VIEW} component={Suite} />
        <Route path={PATHS.VIDEO_CHAT} component={VideoChat} />
        <Route path={PATHS.VIEW_IMAGE} component={ViewImage} />
        <Route path={PATHS.DASHBOARD} component={Dashboard} />
        <Route
          path={PATHS.HOMEOWNER_ONBOARDING_DASHBOARD}
          component={OnboardingDashboard}
        />
        <Route path={PATHS.EVENT_ADDING} component={EventAddingWithCalendly} />
        <Route
          path={checkAnnouncement?.name ? PATHS.ANNOUNCEMENTS : PATHS.DASHBOARD}
          component={checkAnnouncement?.name ? Announcements : Dashboard}
        />
        <Route path={PATHS.ANNOUNCEMENTS_VIEW} component={Announcementsview} />
        <Route path={PATHS.COMMON_AREA_VIEW} component={CommonArea} />
        <Route path={PATHS.REPORTING} component={Reporting} />
        <Route
          path={showInbox ? PATHS.INBOX : PATHS.DASHBOARD}
          component={showInbox ? InboxContainer : Dashboard}
        />
        <Route path="/">
          <Redirect to={PATHS.DASHBOARD} />
        </Route>
    </Switch>
  );
};

export default HomeownerRoutes;
